/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ViennaAddressSearchResult } from './ViennaAddressSearchResult';
import {
    ViennaAddressSearchResultFromJSON,
    ViennaAddressSearchResultFromJSONTyped,
    ViennaAddressSearchResultToJSON,
    ViennaAddressSearchResultToJSONTyped,
} from './ViennaAddressSearchResult';

/**
 * 
 * @export
 * @interface SearchResultsOfViennaAddressSearchResult
 */
export interface SearchResultsOfViennaAddressSearchResult {
    /**
     * 
     * @type {Array<ViennaAddressSearchResult>}
     * @memberof SearchResultsOfViennaAddressSearchResult
     */
    data: Array<ViennaAddressSearchResult>;
    /**
     * 
     * @type {boolean}
     * @memberof SearchResultsOfViennaAddressSearchResult
     */
    hasMoreItems: boolean;
}

/**
 * Check if a given object implements the SearchResultsOfViennaAddressSearchResult interface.
 */
export function instanceOfSearchResultsOfViennaAddressSearchResult(value: object): value is SearchResultsOfViennaAddressSearchResult {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('hasMoreItems' in value) || value['hasMoreItems'] === undefined) return false;
    return true;
}

export function SearchResultsOfViennaAddressSearchResultFromJSON(json: any): SearchResultsOfViennaAddressSearchResult {
    return SearchResultsOfViennaAddressSearchResultFromJSONTyped(json, false);
}

export function SearchResultsOfViennaAddressSearchResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchResultsOfViennaAddressSearchResult {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(ViennaAddressSearchResultFromJSON)),
        'hasMoreItems': json['hasMoreItems'],
    };
}

export function SearchResultsOfViennaAddressSearchResultToJSON(json: any): SearchResultsOfViennaAddressSearchResult {
    return SearchResultsOfViennaAddressSearchResultToJSONTyped(json, false);
}

export function SearchResultsOfViennaAddressSearchResultToJSONTyped(value?: SearchResultsOfViennaAddressSearchResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(ViennaAddressSearchResultToJSON)),
        'hasMoreItems': value['hasMoreItems'],
    };
}

